//@flow
import MembershipStoreClass from './membershipStoreClass';

export default new MembershipStoreClass();
